import React, { useState } from "react";
import FetchChartsAirportYear from "./FetchChartsAirportYear";
import FetchAllAirportsCharts from "./FetchAllAirportsCharts";
import FetchNutsCharts from "./FetchNutsCharts";
import FetchChartsAirportMonth from "./FetchChartsAirportMonth";
import FetchNutsMonthCharts from "./FetchNutsMonthCharts";
import FetchAllAirportsMonthCharts from "./FetchAllAirportsMonthCharts";
import DayAirportResult from "./DayAirportResult";
import DayAllAirportResult from "./DayAllAirportsResult";
import DayNutsCharts from "./DayNutsCharts";

function AirportTrafficResults({
  TimeOption,
  RegionIndicator,
  Time,
  MeasurementIndicator,
  AirportCodes,
  NutsSelection,
  startDate,
  endDate,
}) {
  const [selectedButtonIndex, setSelectedButtonIndex] = useState(null);
  let component;

  const handleButtonClick = (buttonIndex) => {
    setSelectedButtonIndex(buttonIndex);
  };

  const buttonStyle = {
    backgroundColor: "white",
    border: "none",
    borderRadius: "4px",
    padding: "8px 16px",
    margin: "0 8px",
    cursor: "pointer",
  };

  const selectedButtonStyle = {
    ...buttonStyle,
    backgroundColor: "rgb(0, 102, 255)",
    color: "black",
  };

  //SWITCH-CASE for the selected Chart Type
  switch (selectedButtonIndex) {
    case 0:
      switch (RegionIndicator) {
        case "Αεροδρόμιο":
          if (TimeOption === "Ανα έτος") {
            component = (
              <FetchChartsAirportYear
                TimeOption={TimeOption}
                RegionIndicator={RegionIndicator}
                Time={Time}
                MeasurementIndicator={MeasurementIndicator}
                AirportCode={AirportCodes}
                chartType={0}
              />
            );
          } else if (TimeOption === "Ανα μήνα") {
            component = (
              <FetchChartsAirportMonth
                TimeOption={TimeOption}
                RegionIndicator={RegionIndicator}
                Time={Time}
                MeasurementIndicator={MeasurementIndicator}
                AirportCodes={AirportCodes}
                startDate={startDate}
                endDate={endDate}
                chartType={0}
              />
            );
          } else {
            component = (
              <DayAirportResult
                TimeOption={TimeOption}
                Time={startDate}
                RegionIndicator={RegionIndicator}
                MeasurementIndicator={MeasurementIndicator}
                AirportCodes={AirportCodes}
                chartType={0}
              />
            );
          }
          break;
        case "Γεωγραφική περιοχή":
          if (TimeOption === "Ανα έτος") {
            component = (
              <FetchNutsCharts
                TimeOption={TimeOption}
                RegionIndicator={RegionIndicator}
                Time={Time}
                MeasurementIndicator={MeasurementIndicator}
                AirportCode={AirportCodes}
                chartType={0}
                NutsSelection={NutsSelection}
              />
            );
          } else if (TimeOption === "Ανα μήνα") {
            component = (
              <FetchNutsMonthCharts
                TimeOption={TimeOption}
                RegionIndicator={RegionIndicator}
                Time={Time}
                MeasurementIndicator={MeasurementIndicator}
                AirportCode={AirportCodes}
                chartType={0}
                startDate={startDate}
                endDate={endDate}
                NutsSelection={NutsSelection}
              />
            );
          } else {
            component = (
              <DayNutsCharts
                TimeOption={TimeOption}
                Time={startDate}
                RegionIndicator={RegionIndicator}
                MeasurementIndicator={MeasurementIndicator}
                chartType={0}
                NutsSelection={NutsSelection}
              ></DayNutsCharts>
            );
          }

          break;
        case "Σύνολο Αεροδρομίων":
          if (TimeOption === "Ανα έτος") {
            component = (
              <FetchAllAirportsCharts
                TimeOption={TimeOption}
                RegionIndicator={RegionIndicator}
                Time={Time}
                MeasurementIndicator={MeasurementIndicator}
                AirportCode={AirportCodes}
                chartType={0}
              />
            );
          } else if (TimeOption === "Ανα μήνα") {
            component = (
              <FetchAllAirportsMonthCharts
                TimeOption={TimeOption}
                RegionIndicator={RegionIndicator}
                Time={Time}
                MeasurementIndicator={MeasurementIndicator}
                AirportCode={AirportCodes}
                startDate={startDate}
                endDate={endDate}
                chartType={0}
              />
            );
          } else {
            component = (
              <DayAllAirportResult
                TimeOption={TimeOption}
                RegionIndicator={RegionIndicator}
                Time={startDate}
                MeasurementIndicator={MeasurementIndicator}
                AirportCode={AirportCodes}
                chartType={0}
              />
            );
          }

          break;
        default:
          component = <h1>Please Select All Values</h1>;
      }

      break;
    case 1:
      switch (RegionIndicator) {
        case "Αεροδρόμιο":
          if (TimeOption === "Ανα έτος") {
            component = (
              <FetchChartsAirportYear
                TimeOption={TimeOption}
                RegionIndicator={RegionIndicator}
                Time={Time}
                MeasurementIndicator={MeasurementIndicator}
                AirportCode={AirportCodes}
                chartType={1}
              />
            );
          } else if (TimeOption === "Ανα μήνα") {
            component = (
              <FetchChartsAirportMonth
                TimeOption={TimeOption}
                RegionIndicator={RegionIndicator}
                Time={Time}
                MeasurementIndicator={MeasurementIndicator}
                AirportCodes={AirportCodes}
                startDate={startDate}
                endDate={endDate}
                chartType={1}
              />
            );
          } else {
            component = (
              <DayAirportResult
                TimeOption={TimeOption}
                RegionIndicator={RegionIndicator}
                Time={startDate}
                MeasurementIndicator={MeasurementIndicator}
                AirportCodes={AirportCodes}
                chartType={1}
              />
            );
          }

          break;
        case "Γεωγραφική περιοχή":
          if (TimeOption === "Ανα έτος") {
            component = (
              <FetchNutsCharts
                TimeOption={TimeOption}
                RegionIndicator={RegionIndicator}
                Time={Time}
                MeasurementIndicator={MeasurementIndicator}
                AirportCode={AirportCodes}
                chartType={1}
                NutsSelection={NutsSelection}
              />
            );
          } else if (TimeOption === "Ανα μήνα") {
            component = (
              <FetchNutsMonthCharts
                TimeOption={TimeOption}
                RegionIndicator={RegionIndicator}
                Time={Time}
                MeasurementIndicator={MeasurementIndicator}
                AirportCode={AirportCodes}
                chartType={1}
                startDate={startDate}
                endDate={endDate}
                NutsSelection={NutsSelection}
              />
            );
          } else {
            component = (
              <DayNutsCharts
                TimeOption={TimeOption}
                Time={startDate}
                RegionIndicator={RegionIndicator}
                MeasurementIndicator={MeasurementIndicator}
                chartType={1}
                NutsSelection={NutsSelection}
              ></DayNutsCharts>
            );
          }

          break;
        case "Σύνολο Αεροδρομίων":
          if (TimeOption === "Ανα έτος") {
            component = (
              <FetchAllAirportsCharts
                TimeOption={TimeOption}
                RegionIndicator={RegionIndicator}
                Time={Time}
                MeasurementIndicator={MeasurementIndicator}
                AirportCode={AirportCodes}
                chartType={1}
              />
            );
          } else if (TimeOption === "Ανα μήνα") {
            component = (
              <FetchAllAirportsMonthCharts
                TimeOption={TimeOption}
                RegionIndicator={RegionIndicator}
                Time={Time}
                MeasurementIndicator={MeasurementIndicator}
                AirportCode={AirportCodes}
                startDate={startDate}
                endDate={endDate}
                chartType={1}
              />
            );
          } else {
            component = (
              <DayAllAirportResult
                TimeOption={TimeOption}
                RegionIndicator={RegionIndicator}
                Time={startDate}
                MeasurementIndicator={MeasurementIndicator}
                AirportCode={AirportCodes}
                chartType={1}
              />
            );
          }

          break;
        default:
          component = <h1>Please Select All Values</h1>;
      }

      break;
    case 2:
      switch (RegionIndicator) {
        case "Αεροδρόμιο":
          if (TimeOption === "Ανα έτος") {
            component = (
              <FetchChartsAirportYear
                TimeOption={TimeOption}
                RegionIndicator={RegionIndicator}
                Time={Time}
                MeasurementIndicator={MeasurementIndicator}
                AirportCode={AirportCodes}
                chartType={2}
              />
            );
          } else if (TimeOption === "Ανα μήνα") {
            component = (
              <FetchChartsAirportMonth
                TimeOption={TimeOption}
                RegionIndicator={RegionIndicator}
                Time={Time}
                MeasurementIndicator={MeasurementIndicator}
                AirportCodes={AirportCodes}
                startDate={startDate}
                endDate={endDate}
                chartType={2}
              />
            );
          } else {
            component = (
              <DayAirportResult
                TimeOption={TimeOption}
                RegionIndicator={RegionIndicator}
                Time={startDate}
                MeasurementIndicator={MeasurementIndicator}
                AirportCodes={AirportCodes}
                chartType={2}
              />
            );
          }

          break;
        case "Γεωγραφική περιοχή":
          if (TimeOption === "Ανα έτος") {
            component = (
              <FetchNutsCharts
                TimeOption={TimeOption}
                RegionIndicator={RegionIndicator}
                Time={Time}
                MeasurementIndicator={MeasurementIndicator}
                AirportCode={AirportCodes}
                chartType={2}
                NutsSelection={NutsSelection}
              />
            );
          } else if (TimeOption === "Ανα μήνα") {
            component = (
              <FetchNutsMonthCharts
                TimeOption={TimeOption}
                RegionIndicator={RegionIndicator}
                Time={Time}
                MeasurementIndicator={MeasurementIndicator}
                AirportCode={AirportCodes}
                chartType={2}
                startDate={startDate}
                endDate={endDate}
                NutsSelection={NutsSelection}
              />
            );
          } else {
            component = (
              <DayNutsCharts
                TimeOption={TimeOption}
                Time={startDate}
                RegionIndicator={RegionIndicator}
                MeasurementIndicator={MeasurementIndicator}
                chartType={2}
                NutsSelection={NutsSelection}
              ></DayNutsCharts>
            );
          }
          break;
        case "Σύνολο Αεροδρομίων":
          if (TimeOption === "Ανα έτος") {
            component = (
              <FetchAllAirportsCharts
                TimeOption={TimeOption}
                RegionIndicator={RegionIndicator}
                Time={Time}
                MeasurementIndicator={MeasurementIndicator}
                AirportCode={AirportCodes}
                chartType={2}
              />
            );
          } else if (TimeOption === "Ανα μήνα") {
            component = (
              <FetchAllAirportsMonthCharts
                TimeOption={TimeOption}
                RegionIndicator={RegionIndicator}
                Time={Time}
                MeasurementIndicator={MeasurementIndicator}
                AirportCode={AirportCodes}
                startDate={startDate}
                endDate={endDate}
                chartType={2}
              />
            );
          } else {
            component = (
              <DayAllAirportResult
                TimeOption={TimeOption}
                RegionIndicator={RegionIndicator}
                Time={startDate}
                MeasurementIndicator={MeasurementIndicator}
                AirportCode={AirportCodes}
                chartType={2}
              />
            );
          }

          break;
        default:
          component = <h1>Please Select All Values</h1>;
      }

      break;

    case 3:
      switch (RegionIndicator) {
        case "Αεροδρόμιο":
          if (TimeOption === "Ανα έτος") {
            component = (
              <FetchChartsAirportYear
                TimeOption={TimeOption}
                RegionIndicator={RegionIndicator}
                Time={Time}
                MeasurementIndicator={MeasurementIndicator}
                AirportCode={AirportCodes}
                chartType={3}
              />
            );
          } else if (TimeOption === "Ανα μήνα") {
            component = (
              <FetchChartsAirportMonth
                TimeOption={TimeOption}
                RegionIndicator={RegionIndicator}
                Time={Time}
                MeasurementIndicator={MeasurementIndicator}
                AirportCodes={AirportCodes}
                startDate={startDate}
                endDate={endDate}
                chartType={3}
              />
            );
          } else {
            component = (
              <DayAirportResult
                TimeOption={TimeOption}
                RegionIndicator={RegionIndicator}
                Time={startDate}
                MeasurementIndicator={MeasurementIndicator}
                AirportCodes={AirportCodes}
                chartType={3}
              />
            );
          }

          break;
        case "Γεωγραφική περιοχή":
          if (TimeOption === "Ανα έτος") {
            component = (
              <FetchNutsCharts
                TimeOption={TimeOption}
                RegionIndicator={RegionIndicator}
                Time={Time}
                MeasurementIndicator={MeasurementIndicator}
                AirportCode={AirportCodes}
                chartType={3}
                NutsSelection={NutsSelection}
              />
            );
          } else if (TimeOption === "Ανα μήνα") {
            component = (
              <FetchNutsMonthCharts
                TimeOption={TimeOption}
                RegionIndicator={RegionIndicator}
                Time={Time}
                MeasurementIndicator={MeasurementIndicator}
                AirportCode={AirportCodes}
                chartType={3}
                startDate={startDate}
                endDate={endDate}
                NutsSelection={NutsSelection}
              />
            );
          } else {
            component = (
              <DayNutsCharts
                TimeOption={TimeOption}
                Time={startDate}
                RegionIndicator={RegionIndicator}
                MeasurementIndicator={MeasurementIndicator}
                chartType={3}
                NutsSelection={NutsSelection}
              ></DayNutsCharts>
            );
          }
          break;
        case "Σύνολο Αεροδρομίων":
          if (TimeOption === "Ανα έτος") {
            component = (
              <FetchAllAirportsCharts
                TimeOption={TimeOption}
                RegionIndicator={RegionIndicator}
                Time={Time}
                MeasurementIndicator={MeasurementIndicator}
                AirportCode={AirportCodes}
                chartType={3}
              />
            );
          } else if (TimeOption === "Ανα μήνα") {
            component = (
              <FetchAllAirportsMonthCharts
                TimeOption={TimeOption}
                RegionIndicator={RegionIndicator}
                Time={Time}
                MeasurementIndicator={MeasurementIndicator}
                AirportCode={AirportCodes}
                startDate={startDate}
                endDate={endDate}
                chartType={3}
              />
            );
          } else {
            component = (
              <DayAllAirportResult
                TimeOption={TimeOption}
                RegionIndicator={RegionIndicator}
                Time={startDate}
                MeasurementIndicator={MeasurementIndicator}
                AirportCode={AirportCodes}
                chartType={3}
              />
            );
          }

          break;
        default:
          component = <h1>Please Select All Values</h1>;
      }

      break;
    default:
      component = (
        <h3 style={{ marginTop: "5%", fontSize: "20px" }}>
          Παρακαλώ επιλέξτε τύπο διαγράμματος
        </h3>
      );
  }

  return (
    <div style={{ marginTop: "10%" }}>
      <button
        style={selectedButtonIndex === 0 ? selectedButtonStyle : buttonStyle}
        onClick={() => handleButtonClick(0)}
      >
        Ραβδόγραμμα
      </button>
      <button
        style={selectedButtonIndex === 1 ? selectedButtonStyle : buttonStyle}
        onClick={() => handleButtonClick(1)}
      >
        Πίτα
      </button>
      <button
        style={selectedButtonIndex === 2 ? selectedButtonStyle : buttonStyle}
        onClick={() => handleButtonClick(2)}
      >
        Πίνακας Δεδομένων
      </button>
      {TimeOption === "Ανα μήνα" ? (
        <button
          style={selectedButtonIndex === 3 ? selectedButtonStyle : buttonStyle}
          onClick={() => handleButtonClick(3)}
        >
          Γραμμή
        </button>
      ) : (
        <></>
      )}

      {component}
    </div>
  );
}

export default AirportTrafficResults;
